import React, { PropsWithChildren } from 'react';
import { Button } from '@clariness/button';
import { Flex } from '@clariness/flex';
import { Image } from '@clariness/image';
import { Text } from '@clariness/text';
import genericErrorSrc from 'assets/images/generic-error.png';
import { FormattedMessage } from 'react-intl';

type ServiceErrorProps = {
  onRetry: () => void;
}

export const ServiceError = ({ children, onRetry }: PropsWithChildren<ServiceErrorProps>) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '28px',
        m: 'auto',
      }}
    >
      <Image
        width="213px"
        src={genericErrorSrc}
        alt="Something went wrong illustration"
      />

      <Text
        sx={{
          color: '#707070',
          fontSize: '21px',
        }}
      >
        {children}
      </Text>

      <Button onClick={onRetry}>
        <FormattedMessage
          id="is.generic_error.try_again_button"
          defaultMessage="Try again"
        />
      </Button>
    </Flex>
  );
};
